export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11128.36f72720.jpg";